var _defs, _polyline, _polyline2, _line;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotchplacket01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-80,.cls-79,.cls-78{fill:#fff;stroke:#000;stroke-miterlimit:10;}.cls-80{stroke-width:3px;}.cls-79{stroke-width:1.02px;}.cls-79,.cls-78{stroke-dasharray:4;}"))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-80",
    points: "280.99 106.33 280.99 342.87 214.68 393.42 147.81 342.87 147.81 106.33"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-79",
    points: "277.66 106.33 277.66 340.8 214.67 388.33 151.14 340.8 151.14 106.33"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-78",
    x1: 151.14,
    y1: 213.67,
    x2: 280.99,
    y2: 213.67
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotchplacket01);
export default __webpack_public_path__ + "static/media/NOTCH PLACKET-01.e2100637c41574da52e66eba244fd0f2.svg";
export { ForwardRef as ReactComponent };